module.exports = __webpack_public_path__ + "img/CG1_33.c53e419.png";